export default __webpack_public_path__ + "static/media/health-tip-img.cb154e77.png";